import {styled} from "@core-ui/react-stitch";

const Label = styled.label`
  &:hover {
    text-decoration: underline;
  }
  margin: 0 0 1.5rem;
`;

export default Label;
